import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-tags',
    templateUrl: './tags.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TagsComponent implements OnInit {
  @Input() items?: any;

  selectable = true;
  removable = true;

  constructor() {}

  ngOnInit() {}

  remove(item: string): void {
    const index = this.items.indexOf(item);
    if (index >= 0) {
      this.items.splice(index, 1);
    }
  }
}
